import { SVGProps } from 'react'

export const Send = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className="icon glyph" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M21.66 12a2 2 0 01-1.14 1.81L5.87 20.75A2.08 2.08 0 015 21a2 2 0 01-1.82-2.82L5.46 13H11a1 1 0 000-2H5.46L3.18 5.87a2 2 0 012.68-2.62l14.65 6.94A2 2 0 0121.66 12z"
    ></path>
  </svg>
)
